import { render, staticRenderFns } from "./activity-sales-rank.vue?vue&type=template&id=6c5076c8&scoped=true&"
import script from "./activity-sales-rank.vue?vue&type=script&lang=js&"
export * from "./activity-sales-rank.vue?vue&type=script&lang=js&"
import style0 from "./activity-sales-rank.vue?vue&type=style&index=0&id=6c5076c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5076c8",
  null
  
)

export default component.exports